module.exports = __webpack_public_path__ + "static/media/slide-mobile (3).7fbbe31f.jpg";